import { trpc } from '@/shared/api/trpc';

export const useHyperguestSuggest = () =>
  trpc.hyperguestHotels.suggestMatches.useMutation();
